"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
const devsec_toolkit_1 = require("@hotmart/devsec-toolkit");
const Html = ({ children, className, tag = 'span', id }) => {
    const sanitizedHTML = (0, devsec_toolkit_1.sanitize)({ html: children });
    return (0, react_1.createElement)(tag, {
        id,
        className,
        dangerouslySetInnerHTML: { __html: sanitizedHTML }
    });
};
exports.default = Html;
